import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn } from "@angular/router";
import { AuthService as Auth0Service } from "@auth0/auth0-angular";
import { filter, switchMap, take, tap } from "rxjs/operators";
import { AuthService } from "./auth-service.service";

/**
 * Functional route guard that allows activation only once Auth0 has finished
 * loading and reports an authenticated session; unauthenticated users are
 * redirected to login with the attempted URL as the post-login target.
 */
export const authGuard: CanActivateFn = (route, state) => {
  const auth0 = inject(Auth0Service);
  const authService = inject(AuthService);

  return auth0.isLoading$.pipe(
    filter((loading) => !loading),
    take(1),
    switchMap(() => auth0.isAuthenticated$),
    take(1),
    tap((isAuthenticated) => {
      if (!isAuthenticated) {
        authService.login(state.url);
      }
    }),
  );
};

/**
 * Functional child-route guard applying the same Auth0 authentication check
 * as {@link authGuard} to nested routes.
 */
export const childAuthGuard: CanActivateChildFn = (route, state) => {
  const auth0 = inject(Auth0Service);
  const authService = inject(AuthService);

  return auth0.isLoading$.pipe(
    filter((loading) => !loading),
    take(1),
    switchMap(() => auth0.isAuthenticated$),
    take(1),
    tap((isAuthenticated) => {
      if (!isAuthenticated) {
        authService.login(state.url);
      }
    }),
  );
};
